export default {
  recommendedShopsTitle: {
    default: 'Browse More Gear from Top Shops',
    gb: 'Browse More Gear from Shops in the UK',
    inCountry: 'Browse More Gear from Shops in {{country}}',
    nl: 'Browse More Gear from Shops in the Netherlands',
  },
};
